import React, { useEffect, useState } from 'react';
import StepFormWidget from '../StepFormWidget/StepFormWidget';
import { useModal } from '../../context/ModalContext';
import './PopupModal.css';

const PopupModal = () => {
  const { isOpen, openModal, closeModal } = useModal();
  const [dismissed, setDismissed] = useState(false);

  // Auto-open after 5 seconds (once, unless dismissed)
  useEffect(() => {
    if (dismissed) return;
    const timer = setTimeout(() => openModal(), 5000);
    return () => clearTimeout(timer);
  }, [dismissed, openModal]);

  const close = () => {
    closeModal();
    setDismissed(true);
  };

  // Close on Escape key
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') close(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);

  // Lock body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="popup-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) close(); }}
    >
      {/* Scroll wrapper sits INSIDE overlay, allows scrolling on overflow */}
      <div className="popup-scroll-wrapper">
        <div
          className="popup-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Free Counselling Form"
        >
          {/* Header */}
          <div className="popup-header">
            <div className="popup-header-left">
              <div className="popup-badge">🎯 Limited Seats for 2026</div>
              <h3 className="popup-title">Get Your Free MBBS Counselling</h3>
              <p className="popup-subtitle">Takes just 2 minutes · Expert callback within 24 hrs</p>
            </div>
            <button className="popup-close" onClick={close} aria-label="Close">✕</button>
          </div>

          {/* Trust bar */}
          <div className="popup-trust-bar">
            <span>🔒 100% Free</span>
            <span>⚡ 24-hr Response</span>
            <span>🌟 No Obligation</span>
          </div>

          {/* Form */}
          <div className="popup-form-wrap">
            <StepFormWidget onClose={close} />
          </div>

        </div>
      </div>
    </div>
  );
};

export default PopupModal;